module.exports = __webpack_public_path__ + "static/media/20170806_49day_2350AT.3392353c.jpg";